
import RiskLevelMixin from '../mixins/risk.mixin'
import StartBankIcon from './startBankIcon.vue'

export default {
    name: 'RiskTags',
    mixins: [RiskLevelMixin],
    components: {
        StartBankIcon,
    },
    props: {
        startBankData: {
            type: Object,
        },
    },
    computed: {
        riskStatus() {
            return this.sortedStatus[0] || this.startBankData?.risk?.status
        },
        sortedStatus() {
            if (!Array.isArray(this.startBankData?.risk?.tags)) {
                return []
            }

            return Array.from(
                new Set(this.startBankData.risk.tags.map((tag: any) => tag.status))
            ).sort()
        },
        tagsByStatus(): Record<string, string[]> {
            if (!Array.isArray(this.startBankData?.risk?.tags)) {
                return {}
            }

            return this.startBankData.risk.tags.reduce((list: any, tag: any) => {
                if (typeof list[tag.status] === 'undefined') {
                    list[tag.status] = []
                }
                list[tag.status].push(tag.text_nob)
                return list
            }, {})
        },
    },
}
